export const selectCapabilities = state => state?.capabilities || {}
export const selectAgendaCapable = state =>
  !!(state?.capabilities?.checked && state?.capabilities?.agenda)
export const selectTasksCapable = state =>
  !!(state?.capabilities?.checked && state?.capabilities?.tasks)
